import React, { useContext, useEffect, useState } from "react";
import { DashboardContext } from "context/DashboardContext";
import { ModalContext } from "context/ModalContext";
import { api_srv } from "services";
import { show_toast } from "utils/helpers";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Input, Pagination } from 'antd';
import AddRate from "components/widgets/modals/AddRate";
import { list_rates } from "services/apiSrv";
import { useQuery } from "react-query";


export default function NewRate() {

    const { data: rates, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["rates"],
    queryFn: list_rates,
  });

  console.log("rates===", rates)

  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);

  return (
    <div className="p-4 bg-white rounded #shadow">
       Rates

            <Button className="text-white btn-blue rounded float-right mb-3" onClick={() => setModalShow(true)}>
                Add Rate
            </Button>
          
           <AddRate show={modalShow} onHide={modalClose}fetchCharges={refetch} />

              <div className="card-body pd-0 collapse show" id="customerDetails">
                <div className="table-responsive">
                  <table className="table table-hover mg-0">
                    <thead className="tx-dark tx-uppercase tx-12 tx-bold">
                      <tr className="bg-light">
                        <th className="">Name</th>
                        <th className="">Code</th>
                        <th className="">Description</th>
                        <th className="">value</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {/* <tbody>{items}</tbody> */}
                     {rates?.data?.map((item) => (
                       <tr key={item.id}>
                         <td>{item.rateName}</td>
                          <td>{item.rateCode}</td>
                         <td>{item.rateDescription}</td>
                         <td>{item.rateValue}</td>
                         <td>
                           <Button onClick={() => (item.id)}>Delete</Button>
                         </td>
                       </tr>
                     ))}
                  </table>
                </div>
              </div>
       
    </div>
  );
}